export const ALL_CATEGORIES = [
  {
    id: "stores",
    short: { en: "Stores", pt: "Lojas" },
    title: {
      en: "Top TCG Stores",
      pt: "Melhores Lojas TCG",
    },
    title_parts: {
      en: { lead: "Top TCG", highlight: "Stores", trail: "" },
      pt: { lead: "Melhores", highlight: "Lojas", trail: "TCG" },
    },
    description: {
      en: "The best physical and online stores in Portugal.",
      pt: "As melhores lojas físicas e online em Portugal.",
    },
    criteria: [
      { key: "selection", name: { en: "Selection & Inventory", pt: "Seleção e Inventário" }, weight: 35 },
      { key: "pricing", name: { en: "Pricing & Trade Value", pt: "Preços e Valor de Troca" }, weight: 30 },
      { key: "space_events", name: { en: "Store Space & Events", pt: "Espaço e Eventos" }, weight: 25 },
      { key: "service", name: { en: "Service & Communication", pt: "Atendimento e Comunicação" }, weight: 10 },
    ],
  },
  {
    id: "vending",
    short: { en: "Vending", pt: "Vending" },
    title: {
      en: "Top TCG Vending Machines",
      pt: "Melhores Máquinas de Vending TCG",
    },
    title_parts: {
      en: { lead: "Top TCG", highlight: "Vending", trail: "Machines" },
      pt: { lead: "Melhores Máquinas de", highlight: "Vending", trail: "TCG" },
    },
    description: {
      en: "Automated mystery booster and card vending setups across shopping centers and gaming spots in Portugal.",
      pt: "Máquinas automáticas de mystery boosters e cartas em centros comerciais e espaços gaming por todo o país.",
    },
    criteria: [
      { key: "pull_value", name: { en: "Pull Value & Mystery Rate", pt: "Valor dos Pulls e Mistério" }, weight: 40 },
      { key: "reliability", name: { en: "Machine Reliability", pt: "Fiabilidade da Máquina" }, weight: 30 },
      { key: "restock", name: { en: "Restock Speed & Locations", pt: "Reposição e Localizações" }, weight: 30 },
    ],
  },
  {
    id: "events",
    short: { en: "Events", pt: "Eventos" },
    title: {
      en: "Top Card Show Events",
      pt: "Melhores Eventos TCG",
    },
    title_parts: {
      en: { lead: "Top Card Show", highlight: "Events", trail: "" },
      pt: { lead: "Melhores", highlight: "Eventos", trail: "TCG" },
    },
    description: {
      en: "Major regional expos, grand open tournaments, trade conventions and pop-up card swap meets in Portugal.",
      pt: "Expos regionais, grandes torneios abertos, convenções de troca e encontros pop-up em Portugal.",
    },
    criteria: [
      { key: "organization", name: { en: "Organization & Venue", pt: "Organização e Espaço" }, weight: 40 },
      { key: "vendor_diversity", name: { en: "Vendor Diversity", pt: "Diversidade de Expositores" }, weight: 30 },
      { key: "prizes", name: { en: "Activities & Atmosphere", pt: "Atividades e ambiente" }, weight: 30 },
    ],
  },
  {
    id: "creators",
    short: { en: "Creators", pt: "Criadores" },
    title: {
      en: "Top TCG Content Creators",
      pt: "Melhores Criadores de Conteúdo TCG",
    },
    title_parts: {
      en: { lead: "Top TCG Content", highlight: "Creators", trail: "" },
      pt: { lead: "Melhores", highlight: "Criadores", trail: "de Conteúdo" },
    },
    description: {
      en: "Streamers, YouTubers, podcasters and others making full-time or part-time TCG content in Portugal!",
      pt: "Streamers, YouTubers, podcasters e outros que produzem conteúdo exclusivo ou parcial de TCG em Portugal!",
    },
    criteria: [
      { key: "quality", name: { en: "Content Quality & Depth", pt: "Qualidade e Profundidade" }, weight: 40 },
      { key: "consistency", name: { en: "Consistency & Uploads", pt: "Consistência e Uploads" }, weight: 30 },
      { key: "engagement", name: { en: "Community Engagement", pt: "Envolvimento com a Comunidade" }, weight: 30 },
    ],
  },
];

// patch 40: categories hidden from the public site for now (code and data kept; the admin still sees them)
export const HIDDEN_CATEGORIES = new Set(["vending"]);
export const CATEGORIES = ALL_CATEGORIES.filter((c) => !HIDDEN_CATEGORIES.has(c.id));
export const isHiddenCategory = (id) => HIDDEN_CATEGORIES.has(id);

export function findCategory(id) {
  return ALL_CATEGORIES.find((c) => c.id === id);
}

// ---- Store type criteria (weights sum to 100 per type) ----
const C = {
  selection: { en: "Selection & inventory", pt: "Seleção e inventário" },
  pricing: { en: "Pricing & trade value", pt: "Preços e valor de troca" },
  space_events: { en: "Space & events", pt: "Espaço e eventos" },
  website: { en: "Website & ease of purchase", pt: "Website e facilidade de compra" },
  service: { en: "Service & communication", pt: "Atendimento e comunicação" },
};

export const STORE_CRITERIA = {
  fisica: [
    { key: "selection", name: C.selection, weight: 35 },
    { key: "pricing", name: C.pricing, weight: 30 },
    { key: "space_events", name: C.space_events, weight: 25 },
    { key: "service", name: C.service, weight: 10 },
  ],
  online: [
    { key: "selection", name: C.selection, weight: 35 },
    { key: "pricing", name: C.pricing, weight: 30 },
    { key: "website", name: C.website, weight: 25 },
    { key: "service", name: C.service, weight: 10 },
  ],
  ambas: [
    { key: "selection", name: C.selection, weight: 30 },
    { key: "pricing", name: C.pricing, weight: 25 },
    { key: "space_events", name: C.space_events, weight: 25 },
    { key: "website", name: C.website, weight: 10 },
    { key: "service", name: C.service, weight: 10 },
  ],
};

export function storeCriteria(storeType) {
  return STORE_CRITERIA[storeType] || STORE_CRITERIA.fisica;
}

export const STORE_TYPE_LABELS = {
  fisica: { en: "Physical store", pt: "Loja física" },
  online: { en: "Online store", pt: "Loja online" },
  ambas: { en: "Physical + Online", pt: "Física + Online" },
};

export function tierFromScore(score) {
  if (score >= 90) return "S";
  if (score >= 80) return "A";
  if (score >= 70) return "B";
  if (score >= 50) return "C";
  return "D";
}

export const TIER_STYLES = {
  S: { text: "text-amber-300", bg: "bg-gradient-to-br from-amber-500/20 to-red-500/10", border: "border-amber-400/60", glow: "shadow-[0_0_28px_rgba(212,168,44,0.35)]" },
  A: { text: "text-amber-200", bg: "bg-amber-500/10", border: "border-amber-400/40", glow: "shadow-[0_0_14px_rgba(212,168,44,0.2)]" },
  B: { text: "text-emerald-300", bg: "bg-emerald-500/10", border: "border-emerald-500/40", glow: "" },
  C: { text: "text-sky-300", bg: "bg-sky-500/10", border: "border-sky-500/40", glow: "" },
  D: { text: "text-stone-300", bg: "bg-stone-700/40", border: "border-stone-600", glow: "" },
};
